<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
        <el-select v-model="formInline.dealerName" placeholder="名称" clearable>
           <el-option v-for="(item, index) in cartypelista" :key="index" 
            :label="item.dealerName " :value="item.id"></el-option>
        </el-select>
        
        </el-form-item>
          <el-form-item> 
        <el-select v-model="formInline.mcSeriesModel" :placeholder="$t('menu.zckccx')" clearable>
          <el-option v-for="(item, index) in cartypelist" :key="index" v-if="item.dictValue!=='9000'"
            :label="inle == 'zh' ? item.dictLabel : item.dictLabelEn" :value="item.dictValue"></el-option>
        </el-select>
          
        </el-form-item>
         <el-form-item>
            <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
         </el-form-item>
      </el-form>
      <div class="bonntbot">
        <el-tabs v-model="action" @tab-click="searchType">
          <el-tab-pane v-for="(item, index) in titleList" :key="index"
            :label="item.num !== 0 ? item.dictLabel + '(' + item.num + ')' : item.dictLabel"
            :name="item.dictValue"></el-tab-pane>

        </el-tabs>

        <!-- <div class="bonntbota">
         导出
        </div> -->

      </div>


    </div>




    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="dealerName" :label="$t('menu.zcmxlsh')" > </el-table-column>
      <el-table-column prop="mcSeriesModel" :label="$t('menu.zckccx')" > 
        <template slot-scope="scope">
          {{ pa1(scope.row.mcSeriesModel) }}
        </template> 
      </el-table-column>
     
      <el-table-column prop="motorColor" :label="$t('menu.zckcyc')" > </el-table-column>
      <el-table-column prop="currentStock" :label="$t('menu.zckcdqkc')"> </el-table-column>
      <el-table-column prop="safetyStock" :label="$t('menu.zckckcxx')" > </el-table-column>
      <el-table-column prop="status" :label="$t('menu.zckczt')" >
        <template slot-scope="scope">
          {{ pa2(scope.row.status) }}
        </template> 
      </el-table-column>
      <el-table-column prop="noticeTitle" :label="$t('menu.zckccz')">
        <template slot-scope="scope">
           <el-button type="text" size="mini" @click="eder(scope.row)" >{{$t('menu.zckcyjsz')}}</el-button>
       
        </template>
      </el-table-column>
    </el-table>
    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>

            <el-dialog
              :title="$t('menu.zckcyjsz')"
              :visible.sync="dialogVisible"
              :close-on-click-modal="false"
              width="30%"
             >
             <div>
              {{$t('menu.zckckcxx')}}：
              <el-input v-model="id.safetyStock" placeholder="请输入内容"></el-input>
             </div>
              <span slot="footer" class="dialog-footer">
                
                <el-button @click="dialogVisible = false">{{$t('menu.Cancel')}}</el-button>
                <el-button type="primary" @click="edup()">{{$t('menu.Confirm')}}</el-button>
              </span>
            </el-dialog>
  
  </div>
</template>

<script>
import { stockOfDealerlist,querytype,edstockOfDealer,retailerlist } from "../../api/api";
import Utils  from "../../utils/uilt.js";
export default {
  data () {
    return {
      cartypelist:[],
     vaule:'',
      id:'',
      dialogVisible: false,
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
    
      action: '5',
      inle: 'zh',
      titleList: [
        {
          dictValue: '5',
          dictLabel: this.$t('menu.All'),
          num: 0
        },
        {
          dictValue: '1',
          dictLabel: this.$t('menu.zckckccz'),
          num: 0
        },
        {
          dictValue: '2',
          dictLabel: this.$t('menu.zckckcjz'),
          num: 0
        },
        {
          dictValue: '0',
          dictLabel: this.$t('menu.zckczwkc'),
          num: 0
        }
      
      ],
      
      mation: [], //列表
      formInline: {
        dealerName: "",
        status: "",
        mcSeriesModel: "",
      },
    
     cartypelista:[],
      num: [],
    };
  },
  created () {
    this.biao();
    this.getQuerytype()
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.getQuerytypea()
  },
 
  
  methods: {
    
     //零售商
    getQuerytypea () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelista = r.data.rows;
    
      })
    },
    pa2(e){
      let a =''
      this.titleList.forEach(z=>{
        if(z.dictValue==e){
          if(this.inle=='zh'){
             a=z.dictLabel
          }else{
             a=z.dictLabel
          }
         
        }
      })
      return a 
    },
     pa1(e){
      let a =''
      this.cartypelist.forEach(z=>{
        if(z.dictValue==e){
          a=z.dictLabel
        }
      })
      return a 
    },
    //车型
     getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        
        this.cartypelist = r.data.data;
      
      })
    },
   
  
    searchType (tab, event) {
    
      
      this.action = tab.name
      this.formInline.status= tab.name
      this.biao()
      
    },
   
 
    search () {
      this.biao()
    },
    async biao () {
      // stockOfDealerlist(data, dealerName, curPage, pageSize,mcSeriesModel,status,)
      let param = new URLSearchParams();
      let dealerName = this.formInline.dealerName;
      let mcSeriesModel = this.formInline.mcSeriesModel;
     
      let status = this.action;
      if(status=='5'){
        status=''
      }
      const { data: res } = await stockOfDealerlist(
        param,
        dealerName,
         this.currentPage3,
         this.pagesize,
         mcSeriesModel,
        status,
        1
      );

      this.mation = res.rows;
      this.num = res.summary
      this.num.forEach(z=>{
        this.titleList.forEach((zz,zzz)=>{
            if(z.status==zz.dictValue){
              this.titleList[zzz].num=z.sum
            }
        })
      })
      this.totale = res.total;
    
    },
  
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao();
    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao();
    },
    downLoad (row) {
      const a = document.createElement('a')

      a.href = this.common.httpUrl + row.filePath
      // a.href = 'http://fdms-test.bendamotor.cn/bendaFDMSTestWeb' + row.filePath
      a.download = row.fileName // 下载后文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
      eder(e){
    this.dialogVisible=true
    let a = 0 
    a=e.safetyStock
    this.vaule=a
    this.id={...e}
  },
  edup(){
         let param = this.id
    
      
  
     edstockOfDealer(param).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('成功')
            this.dialogVisible = false
          this.biao()
        } else {
          this.$message.error('失败')
        }
      })
  },
  }

};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;
  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.pop {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .btn1 {
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #409eff;
    }
  }

  .content {
    margin-bottom: 20px;
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}
.cbjqq{
  margin-right: 10px;
  cursor: pointer;
  color: #409eff;
}
/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

.cctitle {
  color: #999999;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;

  p {
    cursor: pointer;
  }
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.row-title {
  font-size: 18px;
  color: #222222;
  font-weight: 550;
}

.content-box {
  position: relative;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 8px 4px;

  .qianshou {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>